module.exports = __webpack_public_path__ + "img/tx.5c67d083.png";